import { Gesture } from "./gestures.types";

export const isOneFingerTouch = (event: TouchEvent) =>
    event.touches.length === Gesture.ONE_FINGER;

export const isTwoFingersTouch = (event: TouchEvent) =>
    event.touches.length === Gesture.TWO_FINGERS;

export const distance = (a: Touch, b: Touch) => {
    const dx = a.clientX - b.clientX;
    const dy = a.clientY - b.clientY;
    return Math.hypot(dx, dy);
};

export const midpoint = (a: Touch, b: Touch): { x: number; y: number } => ({
    x: (a.clientX + b.clientX) / 2,
    y: (a.clientY + b.clientY) / 2,
});

export function getTouchPair(event: TouchEvent): [Touch, Touch] {
    if (event.touches.length !== 2) {
        throw new Error("Expected exactly two touches for a pinch gesture");
    }
    return [event.touches[0], event.touches[1]];
}
